import { login, logout, validateToken } from "@/api/login";
import { getToken, removeToken } from "@/utils/auth";

const user = {
  state: {
    token: getToken() || "",
    name: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, { username, password, device, isReset }) {
      return new Promise((resolve, reject) => {
        login(username, password, device, isReset)
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              commit("SET_TOKEN", data.token);
              commit("SET_NAME", username);
              resolve({message: data.message, enablePc: data.enablePc});
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    async GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        validateToken()
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              commit("SET_NAME", data.username);
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_NAME", "");
            removeToken();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_NAME", "");
        removeToken();
        resolve();
      });
    }
  }
};

export default user;
